var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#848D27",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16.5V22.5C19.5 22.7652 19.3946 23.0196 19.2071 23.2071C19.0196 23.3946 18.7652 23.5 18.5 23.5H10.5C10.2348 23.5 9.98043 23.3946 9.79289 23.2071C9.60536 23.0196 9.5 22.7652 9.5 22.5V10.5C9.5 10.2348 9.60536 9.98043 9.79289 9.79289C9.98043 9.60536 10.2348 9.5 10.5 9.5H12.5",
    stroke: "#848D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.5H17.5L14.5 16.5V9.5C14.5 9.23478 14.6054 8.98043 14.7929 8.79289C14.9804 8.60536 15.2348 8.5 15.5 8.5H22.5C22.7652 8.5 23.0196 8.60536 23.2071 8.79289C23.3946 8.98043 23.5 9.23478 23.5 9.5V13.5C23.5 13.7652 23.3946 14.0196 23.2071 14.2071C23.0196 14.3946 22.7652 14.5 22.5 14.5Z",
    stroke: "#848D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.3babd6064c321067c98b387edd6c3a38.svg";
export { ForwardRef as ReactComponent };